var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstancesHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic instances",
    clipPath: "url(#clip0_9146_76092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic instances"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4028 7.54167H3.59722C2.50757 7.54167 1.625 6.6591 1.625 5.56944V3.59722C1.625 2.50757 2.50757 1.625 3.59722 1.625H17.4028C18.4924 1.625 19.375 2.50757 19.375 3.59722V5.56944C19.375 6.6591 18.4924 7.54167 17.4028 7.54167Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4028 13.4557H3.59722C2.50757 13.4557 1.625 12.5732 1.625 11.4835V9.51128C1.625 8.42163 2.50757 7.53906 3.59722 7.53906H17.4028C18.4924 7.53906 19.375 8.42163 19.375 9.51128V11.4835C19.375 12.5732 18.4924 13.4557 17.4028 13.4557Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.4028 19.3776H3.59722C2.50757 19.3776 1.625 18.495 1.625 17.4054V15.4332C1.625 14.3435 2.50757 13.4609 3.59722 13.4609H17.4028C18.4924 13.4609 19.375 14.3435 19.375 15.4332V17.4054C19.375 18.495 18.4924 19.3776 17.4028 19.3776Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.4858 5.56597H5.56912C5.0238 5.56597 4.58301 5.12419 4.58301 4.57986C4.58301 4.03553 5.0238 3.59375 5.56912 3.59375H11.4858C12.0311 3.59375 12.4719 4.03553 12.4719 4.57986C12.4719 5.12419 12.0311 5.56597 11.4858 5.56597Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.4304 5.56597C15.9751 5.56597 16.4166 5.12448 16.4166 4.57986C16.4166 4.03525 15.9751 3.59375 15.4304 3.59375C14.8858 3.59375 14.4443 4.03525 14.4443 4.57986C14.4443 5.12448 14.8858 5.56597 15.4304 5.56597Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.4858 11.4878H5.56912C5.0238 11.4878 4.58301 11.0461 4.58301 10.5017C4.58301 9.9574 5.0238 9.51562 5.56912 9.51562H11.4858C12.0311 9.51562 12.4719 9.9574 12.4719 10.5017C12.4719 11.0461 12.0311 11.4878 11.4858 11.4878Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.4304 11.4878C15.9751 11.4878 16.4166 11.0464 16.4166 10.5017C16.4166 9.95712 15.9751 9.51562 15.4304 9.51562C14.8858 9.51562 14.4443 9.95712 14.4443 10.5017C14.4443 11.0464 14.8858 11.4878 15.4304 11.4878Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.4858 17.4019H5.56912C5.0238 17.4019 4.58301 16.9601 4.58301 16.4158C4.58301 15.8715 5.0238 15.4297 5.56912 15.4297H11.4858C12.0311 15.4297 12.4719 15.8715 12.4719 16.4158C12.4719 16.9601 12.0311 17.4019 11.4858 17.4019Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.4304 17.4019C15.9751 17.4019 16.4166 16.9604 16.4166 16.4158C16.4166 15.8712 15.9751 15.4297 15.4304 15.4297C14.8858 15.4297 14.4443 15.8712 14.4443 16.4158C14.4443 16.9604 14.8858 17.4019 15.4304 17.4019Z",
    fill: "#BFDFFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstancesHover);
export default __webpack_public_path__ + "static/media/instances-hover.2428ea7912f8aacbd22d472d8290fc33.svg";
export { ForwardRef as ReactComponent };